import Link from "next/link";
import styles from "components/textbox/SearchQueryTextBox.module.scss";
import classNames from "classnames";
import ArrowDownIcon from "images/icons/arrow_bottom.svg";


const SearchQueryTextBox = (props) => {
    const {query, isSelected} = props;
    const onClick = props.onClick || (() => {
    });

    return (
        <div className={classNames(styles.searchQueryWrapper, isSelected && styles.isSelected)} onClick={onClick}>
            <span className={classNames(styles.searchQuery, isSelected && styles.isSelectedQuery)}>{query}</span>
        </div>
    )
};


export const FilterText = (props) => {
    const {name} = props;
    return (
        <span className={styles.filterText}>
            <span>{name}</span>
            <ArrowDownIcon viewBox="0 0 20 20" className={styles.downIcon}/>
        </span>
    )
}

export default SearchQueryTextBox;
